<div class="terms-modal">
  <div class="flex items-center justify-between">
    <div class="terms-title">Member Agreement for Discount Medical Plan(s)</div>

    <button
      mat-icon-button
      class="mat-button mat-icon-button transition-color"
      (click)="closeDialog()"
    >
      <i class="fa fas fa-close"></i>
    </button>
  </div>

  <mat-dialog-content>
    <div>
      <p>
        Disclosures:
        <strong
          >THIS DISCOUNT PLAN IS NOT INSURANCE and is not intended to replace
          health insurance.</strong
        >
        This plan does not meet the minimum creditable coverage requirements
        under M.G.L.c. 111M and 956 CMR 5.00. This plan is not a Qualified
        Health Plan under the Affordable Care Act.
      </p>

      <p>
        The plan provides discounts at certain health care providers for medical
        services.
      </p>

      <p>
        The Plan does not make payments directly to providers of medical
        services. Members must pay for all health care services at the time the
        services are performed but will receive a discount from contracted
        providers.
      </p>

      <p>
        The Discount Medical Plan Organization is Patriot Health Florida, Inc.,
        located at 2540 Metrocentre Blvd Suite #5, West Palm Beach, FL 33407. To
        obtain additional information and an up-to-date list of contracted
        providers by name, city, state, and specialty in your service area, you
        may call Member Services at
        <a href="tel:8553504812">(855) 350-4812</a>, or visit
        <a
          href="https://kells.memberproviders.com"
          target="_blank"
          rel="noopener noreferrer"
          >kells.memberproviders.com</a
        >. This Plan is not available in all states. Plan administrators have no
        liability for providing or guaranteeing service or for the quality of
        service rendered. Participating providers are subject to change without
        notice and are not available in all areas. There is no waiting period.
        You may use the Medical Savings Program on the day your plan becomes
        effective.
      </p>

      <ol>
        <li>
          <strong>Entire Agreement:</strong> All provisions under this
          Agreement, Welcome Letter, Membership Guide, ID card, Application, and
          Product Descriptions constitute the entire Agreement between the
          Company and the Member. This contract is not protected by any state
          Life and Health Guaranty Association. Discounts on professional
          services are not available where prohibited by law.
        </li>

        <li>
          <strong>Complaints:</strong> Any complaint regarding Plan Membership
          should be directed to Member Services at
          <a href="tel:8553504812">(855) 350-4812</a>, by email at
          <a href="mailto:support@mymemberinfo.com">support@mymemberinfo.com</a
          >, or in writing to 2540 Metrocentre Blvd Suite #5, West Palm Beach,
          FL 33407. If you are still dissatisfied after complaint submission,
          you may contact your state insurance department.
        </li>

        <li>
          <strong>Effective Date and Renewal:</strong> Your effective date is
          indicated on your ID card. Your plan will be automatically renewed on
          your effective day, monthly, or annually depending on the option
          chosen, until canceled.
        </li>

        <li>
          <strong>Payment:</strong> By joining this plan, you are authorizing
          KELLS to bill your credit card for the plan you selected. This charge
          will remain in force on a monthly or annual basis until you request to
          cancel.
        </li>

        <li>
          <strong>Plan Rates:</strong> Complete Plan monthly rates: $15.00
          Individual. Complete Plan annual rates: $149.00 Individual.
        </li>

        <li>
          <p>
            <strong>Cancellation:</strong> If you are not completely satisfied,
            you may call <a href="tel:8338797292">(833) 879-7292</a> or email
            <a href="mailto:support@getkells.com">support@getkells.com</a> to
            cancel at any time or you can send a written letter to KELLS, Inc.
            15 West 38 Street, New York, NY 10018. Call to verify that your
            cancellation letter has been received. If you cancel within the
            first thirty (30) days, your membership fee will be refunded, less
            the one-time processing fee except in the states identified below.
            Refunds can take up to five (5) business days to process. If you
            cancel after the first thirty (30) days, your membership will
            terminate at the end of the billing cycle for which you have paid,
            and no refund is due. Once you have successfully canceled, your
            membership will terminate, and you will not be billed further for
            any discount medical plans. If the discount medical plan cancels a
            membership for any reason other than nonpayment of charges, the
            discount medical plan shall make a pro-rata reimbursement of all
            periodic charges to you. When canceling within 30 days of your
            effective date, the processing fee is refundable in the following
            states: Arkansas, Maryland, Rhode Island, and Tennessee.
          </p>

          <p>
            <strong>Applies to Annual Renewals Only:</strong> In the event your
            annual membership has been automatically renewed in any year
            following your initial purchase, if you have not used the plan since
            renewal, you may request a refund of your last annual payment within
            30 days of the charge.
          </p>

          <p>
            <strong>Note to residents of OK:</strong> If you decide to cancel
            the membership within the first thirty (30) days after receipt of
            your membership kit, you will receive a reimbursement of all
            periodic charges paid. The return of all periodic charges shall be
            made within thirty (30) days of the date of the cancellation. If all
            the periodic charges have not been paid within thirty (30) days,
            interest shall be assessed and paid on the proceeds at a rate of the
            Treasury Bill rate of the preceding calendar year, plus two (2)
            percentage points.
          </p>
        </li>

        <li>
          <strong>Best Efforts:</strong> The Company shall use its best efforts
          to obtain acceptance from an adequate number of Providers who will
          agree to provide Eligible Services to Members. The final selection of
          the medical professional and/or medical facility and the approval or
          disapproval of medical treatment is the Member's choice alone.
        </li>

        <li>
          <strong>Member Card:</strong> Member will be provided with an
          electronic Membership Card available for viewing and/or download via
          the KELLS member portal
          <a
            href="https://member.getkells.com"
            target="_blank"
            rel="noopener noreferrer"
            >https://member.getkells.com</a
          >
          or contact customer service at
          <a href="mailto:support@getkells.com">support@getkells.com</a>. Such
          card and other forms of identification should be carried by the Member
          at all times to provide proof of the right to Eligible Services under
          the Membership Agreement. Members can request a physical card be sent
          by mail by contacting KELLS at
          <a href="tel:8338797292">(833) 879-7292</a>. The discounts contained
          herein may not be used in conjunction with any other discount plan.
          All listed or quoted prices are current prices from participating
          providers and are subject to change without notice. From time to time,
          certain providers may offer products and/or services to the general
          public at prices lower than the discounted prices available through
          this Plan. In such an event, members will be charged the lowest price.
          The plan may not be available or vary in some states. Provider lists
          will be provided upon request and sent within three (3) business days.
        </li>

        <li>
          <p>
            <strong>Electronic Delivery Consent:</strong> By enrolling in this
            plan, you consent to receive communications regarding your plan via
            telephone, text message, and auto-dialer technologies with
            pre-recorded messages at the telephone number provided during
            enrollment. Message and data rates may apply. Consent may be revoked
            at any time by calling member services at
            <a href="tel:8553504812">(855) 350-4812</a>.
          </p>

          <p>
            <strong>Note to Texas Consumers:</strong> Regulated by the Texas
            Department of Licensing and Regulation, P.O. Box 12157, Austin,
            Texas 78711; telephone
            <a href="tel:18008039202">1-800-803-9202</a> or
            <a href="tel:5124636599">512-463-6599</a>; website:
            <a
              href="https://www.license.state.tx.us/complaints"
              target="_blank"
              rel="noopener noreferrer"
              >www.license.state.tx.us/complaints</a
            >.
          </p>

          <p>
            <strong>Note to Illinois Consumers:</strong> To file a complaint
            with the Illinois Department of Insurance, please do one of the
            following: Call <a href="tel:8664455364">866 445-5364</a>, visit
            <a
              href="https://mc.insurance.illinois.gov/messagecenter.nsf"
              target="_blank"
              rel="noopener noreferrer"
              >https://mc.insurance.illinois.gov/messagecenter.nsf</a
            >, email to
            <a href="mailto:consumer_complaints@ins.state.il.us"
              >consumer_complaints@ins.state.il.us</a
            >, fax to <a href="tel:2175582083">(217) 558-2083</a>, or mail to
            320 W. Washington Street, Springfield, IL 62767.
          </p>

          <p>
            THIS DISCOUNT PLAN IS NOT HEALTH INSURANCE. THIS PLAN DOES NOT MEET
            THE MINIMUM CREDITABLE COVERAGE REQUIREMENTS UNDER M.G.L. C.111M AND
            956 CMR 5.00. THIS PLAN IS NOT A QUALIFIED HEALTH PLAN UNDER THE
            AFFORDABLE CARE ACT. THE PLAN PROVIDES DISCOUNTS AT CERTAIN HEALTH
            CARE PROVIDERS FOR MEDICAL SERVICES. THE PLAN DOES NOT MAKE PAYMENTS
            DIRECTLY TO PROVIDERS OF MEDICAL SERVICES. MEMBERS ARE REQUIRED TO
            PAY FOR ALL HEALTH CARE SERVICES AT THE TIME THE SERVICES ARE
            PERFORMED BUT WILL RECEIVE A DISCOUNT FROM CONTRACTED PROVIDERS. A
            LISTING OF PARTICIPATING PROVIDERS VIEWED ONLINE OR BY CALLING
            MEMBER SERVICES AT <a href="tel:8553504812">(855) 350-4812</a>. A
            WRITTEN LIST OF PARTICIPATING PROVIDERS IS AVAILABLE BY REQUEST.
            THIS PLAN IS NOT AVAILABLE IN ALL STATES. DISCOUNT MEDICAL PLAN
            ORGANIZATION: PATRIOT HEALTH FLORIDA, INC., LOCATED AT 2540
            METROCENTRE BLVD, SUITE #5, WEST PALM BEACH, FL 33407; PHONE
            <a href="tel:8553504812">(855) 350-4812</a>.
          </p>
        </li>
      </ol>
    </div>
  </mat-dialog-content>
</div>
